import React, { Component } from "react";
import axios from "../utils/axios";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import { MONTH } from "../utils/constants";

export default class Report extends Component {
  state = {
    workstations: [],
    projects: [],
    reportArray: [],
    total: {
      totalArray: [],
      totalHours: 0,
      percentOt: 0,
    },
    smallTable: [],
    isReportReady: false,
    monthText: moment().format("MM-YYYY"),
    smallTableTotal: {
      totalPrevMonth: 0,
      totalCurMonth: 0,
      percentOtPrevMonth: 0,
      percentOtCurMonth: 0,
    },
  };

  getAllTimesheets = async () => {
    try {
      const response = await axios()
        .get(
          `/datas/departments/manhours/month/${this.state.monthText.slice(
            3,
            7
          )}${this.state.monthText.slice(0, 2)}`,
          {
            headers: {
              authorization: "jwt " + localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          // const normal_grandtotal = JSON.parse(
          //   JSON.stringify(res.data[0].project_names)
          // );
          // const ot_grandtotal = JSON.parse(
          //   JSON.stringify(res.data[0].project_names)
          // );
          // res &&
          //   res.data.map(({ department_minutes, project_names, ...rest }) => {
          //     const normal_subtotal = JSON.parse(JSON.stringify(project_names));
          //     const ot_subtotal = JSON.parse(JSON.stringify(project_names));
          //     department_minutes.map(({ project_minutes, ...rest }) => {
          //       const normal_minutes = JSON.parse(
          //         JSON.stringify(project_names)
          //       );
          //       const ot_minutes = JSON.parse(JSON.stringify(project_names));
          //       let normal_total = 0,
          //         ot_total = 0,
          //         total_hours = 0;
          //       project_minutes != null &&
          //         project_minutes.map(({ project_id, ...rest }) => {
          //           normal_minutes.find((o, i) => {
          //             if (o.project_id === project_id) {
          //               o.work_minutes = rest.work_minutes;
          //               ot_minutes[i].ot_minutes = rest.ot_minutes;
          //               normal_total += rest.work_minutes;
          //               ot_total += rest.ot_minutes;
          //               total_hours = normal_total + ot_total;
          //               //
          //               normal_subtotal[i].work_minutes =
          //                 (normal_subtotal.work_minutes || 0) +
          //                 rest.work_minutes;
          //               ot_subtotal[i].ot_minutes =
          //                 (ot_subtotal.work_minutes || 0) + rest.ot_minutes;
          //               normal_grandtotal[i].work_minutes =
          //                 (normal_grandtotal[i].work_minutes || 0) +
          //                 rest.work_minutes;
          //               ot_grandtotal[i].ot_minutes =
          //                 (ot_grandtotal[i].ot_minutes || 0) + rest.ot_minutes;
          //             }
          //           });
          //           project_minutes.normal_minutes = normal_minutes;
          //           project_minutes.ot_minutes = ot_minutes;
          //           //
          //           project_minutes.normal_total = normal_total;
          //           project_minutes.ot_total = ot_total;
          //         });
          //       department_minutes.normal_subtotal = normal_subtotal;
          //       department_minutes.ot_subtotal = ot_subtotal;
          //     });
          //   });
          // res.data.normal_grandtotal = normal_grandtotal;
          // res.data.ot_grandtotal = ot_grandtotal;
          console.log(res);
          return res.data;
        });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  getProjects = async () => {
    try {
      let response = await axios()
        .get(`/projects`, {
          headers: {
            authorization: "jwt " + localStorage.getItem("jwt"),
          },
        })
        .then((res) => {
          return res.data;
        });
      response = response.sort((a, b) => a.id - b.id);
      console.log(response);
      this.setState({ projects: response });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  getWorkStations = async () => {
    try {
      let response = await axios()
        .get(`/workstations`)
        .then((res) => {
          return res.data;
        });
      response = response.sort((a, b) => a.id - b.id);
      this.setState({ workstations: response });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  getDepartments = async () => {
    try {
      let response = await axios()
        .get(`/departments`)
        .then((res) => {
          console.log(res);
          return res.data;
        });
      response = response.sort((a, b) => a.id - b.id);
      this.setState({ departments: response });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  constructReport(departments, workstations, projects, allTimesheets) {
    console.log(departments, workstations, projects, allTimesheets);
    let array = [];
    // departments.map((department) => {
    //   let groupTimesheetsByDepartment = allTimesheets.filter(
    //     (e) => e.department_id === department.id
    //   );
    //   if (groupTimesheetsByDepartment.length > 0) {
    //     let departmentTimesheetsArray = [];
    //     workstations.map((workstation) => {
    //       let workstationTimesheets = [];
    //       let groupTimesheetsByWorkstation = groupTimesheetsByDepartment.filter(
    //         (e) => e.workstation_id === workstation.id
    //       );
    //       if (groupTimesheetsByWorkstation.length > 0) {
    //         let totalWorkHourForWorkStation = 0;
    //         let totalOtHourForWorkStation = 0;
    //         projects.map((project) => {
    //           let timesheet = groupTimesheetsByWorkstation.find(
    //             (e) => e.project_id === project.id
    //           );
    //           if (timesheet) {
    //             workstationTimesheets.push(timesheet);
    //             totalWorkHourForWorkStation += +timesheet.work_minutes;
    //             totalOtHourForWorkStation += +timesheet.ot_minutes;
    //           } else {
    //             workstationTimesheets.push({
    //               project_id: project.id,
    //               work_minutes: 0,
    //               ot_minutes: 0,
    //             });
    //           }
    //         });
    //         workstationTimesheets.push({
    //           work_minutes: totalWorkHourForWorkStation,
    //           ot_minutes: totalOtHourForWorkStation,
    //         });
    //         departmentTimesheetsArray.push({
    //           workstation_name: workstation.name,
    //           projectsArray: workstationTimesheets,
    //           totalHours:
    //             totalWorkHourForWorkStation + totalOtHourForWorkStation,
    //         });
    //       }
    //     });
    //     let projectTotal = [];
    //     projects.map((project) => {
    //       let totalWorkHourProject = 0;
    //       let totalOtHourProject = 0;
    //       let timesheets = groupTimesheetsByDepartment.filter(
    //         (e) => e.project_id === project.id
    //       );
    //       timesheets.map((item) => {
    //         totalWorkHourProject += +item.work_minutes;
    //         totalOtHourProject += +item.ot_minutes;
    //       });
    //       projectTotal.push({
    //         work_minutes: totalWorkHourProject,
    //         ot_minutes: totalOtHourProject,
    //       });
    //     });
    //     let totalWorkDepartment = 0;
    //     let totalOtDepartment = 0;
    //     projectTotal.map((totalProject) => {
    //       totalWorkDepartment += +totalProject.work_minutes;
    //       totalOtDepartment += +totalProject.ot_minutes;
    //     });
    //     projectTotal.push({
    //       work_minutes: totalWorkDepartment,
    //       ot_minutes: totalOtDepartment,
    //     });
    //     departmentTimesheetsArray.push({
    //       isTotal: true,
    //       workstation_name: `${department.name} Total Hour / Project`,
    //       projectsArray: projectTotal,
    //       totalHours: totalWorkDepartment + totalOtDepartment,
    //       percentOt:
    //         (totalOtDepartment * 100) /
    //         (totalWorkDepartment + totalOtDepartment),
    //     });
    //     array.push({
    //       department_name: department.name,
    //       workstationsArray: departmentTimesheetsArray,
    //     });
    //   }
    // });
    // let totalArray = [];
    // let totalHours = 0;
    // let percentOt;
    // for (let i = 0; i <= projects.length; i++) {
    //   let totalWorkProject = 0;
    //   let totalOtProject = 0;
    //   array.map((element) => {
    //     let objectTotal =
    //       element.workstationsArray[element.workstationsArray.length - 1]
    //         .projectsArray[i];
    //     totalWorkProject += +objectTotal.work_minutes;
    //     totalOtProject += +objectTotal.ot_minutes;
    //   });
    //   if (i === projects.length) {
    //     totalHours += totalWorkProject + totalOtProject;
    //     percentOt = (totalOtProject * 100) / totalHours;
    //   }
    //   totalArray.push({
    //     work_minutes: totalWorkProject,
    //     ot_minutes: totalOtProject,
    //   });
    // }
    // let total = {
    //   totalHours,
    //   totalArray,
    //   percentOt,
    // };
    // this.setState({ total });
    return array;
  }

  TimesheetDetails = async () => {
    const month = document.getElementById('month').value;
    const year = document.getElementById('year').value;
    const department_id = 12
    try {
      await axios()
        .get(`/timesheets/department/${department_id}/month/${year}${month}/details`,{responseType: 'blob'})
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'timesheet-details.xlsx');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url)
        })
    }catch (err) {
      console.error(err)
    }
  }

  ManhoursSummary = async () => {
    const month = document.getElementById('month').value;
    const year = document.getElementById('year').value;
    const department_id = 12
    try {
      await axios()
        .get(`/v1/datas/departments/manhours/month/${year}${month}`,{responseType: 'blob'})
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'manhours_summary.xlsx');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url)
        })
    }catch (err) {
      console.error(err)
    }
  }

  prepareTables = async () => {
    this.setState({ isReportReady: false });
    let projects = await this.getProjects();
    let allTimesheets = await this.getAllTimesheets();
    // let projects = await allTimesheets.shift() || [];
    this.setState({projects})
    let workstations = await this.getWorkStations();
    let departments = await this.getDepartments();
    let reportArray = this.constructReport(
      departments,
      workstations,
      projects,
      allTimesheets
    );
    // let reportArray = allTimesheets
    this.setState({ reportArray });
    const smallTable = await this.getSmallTableInfo();
    this.setState({ smallTable });
    let totalPrevMonth = 0;
    let totalCurMonth = 0;
    let totalPrevOt = 0;
    let totalCurOt = 0;
    smallTable.map((item) => {
      totalPrevOt += +item.prevot;
      totalCurOt += +item.curot;
      totalPrevMonth += +item.prevnormal + +item.prevot;
      totalCurMonth += +item.curnormal + +item.curot;
    });
    console.log(totalPrevOt);
    console.log(totalPrevMonth);
    this.setState({
      smallTableTotal: {
        totalPrevMonth,
        totalCurMonth,
        percentOtPrevMonth: (+totalPrevOt * 100) / +totalPrevMonth,
        percentOtCurMonth: (+totalCurOt * 100) / +totalCurMonth,
      },
    });
    this.setState({ isReportReady: true });
  };

  getSmallTableInfo = async () => {
    try {
      let response = await axios()
        .get(
          `/datas/projects/manhours/month/${this.state.monthText.slice(
            3,
            7
          )}${this.state.monthText.slice(0, 2)}`,
          {
            headers: {
              authorization: "jwt " + localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          return res.data;
        });
      console.log(response);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = async () => {
    this.prepareTables();
  };

  _handleMonthChange = (event) => {
    let monthText;
    if (event.target.id === "month") {
      monthText = event.target.value + this.state.monthText.slice(2, 7);
    } else {
      monthText = this.state.monthText.slice(0, 3) + event.target.value;
    }
    this.setState({ isReportReady: false });
    this.setState({ monthText });
  };

  render() {
    return (
      <>
        <section className="content mx-2 mt-1">
          <div className="row m-0">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <form className="d-flex flex-row">
                    <div className="input-group col-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="far fa-calendar-alt" />
                        </span>
                      </div>
                      <select
                        type="text"
                        className="form-control"
                        id="month"
                        value={this.state.monthText.slice(0, 2)}
                        onChange={this._handleMonthChange}
                      >
                        {MONTH.map((item, index) => {
                          let value;
                          if (index + 1 < 10) {
                            value = "0" + (+index + 1);
                          } else {
                            value = index + 1;
                          }
                          return (
                            <option key={index} value={value}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                      <select
                        type="text"
                        className="form-control"
                        id="year"
                        value={this.state.monthText.slice(3, 7)}
                        onChange={this._handleMonthChange}
                      >
                        <option key="3" value={+moment().format("YYYY") - 1}>
                          {+moment().format("YYYY") - 1}
                        </option>
                        <option key="2" value={+moment().format("YYYY")}>
                          {+moment().format("YYYY")}
                        </option>
                        <option key="1" value={+moment().format("YYYY") + 1}>
                          {+moment().format("YYYY") + 1}
                        </option>
                      </select>
                    </div>
                    <div className="input-group-append col-1">
                      <button
                        type="submit"
                        className="btn btn-outline-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          this.prepareTables();
                        }}
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                    {/* /.input group */}
                  </form>
                  {this.state.isReportReady && (
                    <>
                      {/* <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button btn btn-success m-2"
                        table="Big-Table"
                        filename="Department Manhours Summary"
                        sheet="tablexls"
                        buttonText={`Export Department Manhours Summary for ${
                          moment(
                            `${this.state.monthText.slice(3,7)}-${this.state.monthText.slice(0, 2)}`
                          ).format("MMM YYYY") === "Invalid date"
                            ? ""
                            : moment(
                                `${this.state.monthText.slice(
                                  3,
                                  7
                                )}-${this.state.monthText.slice(0, 2)}`
                              ).format("MMM YYYY")
                        }`}
                      /> */}
                      <button type="submit" className="btn btn-outline-primary"
                        onClick={e=>{
                          e.preventDefault();
                          this.ManhoursSummary()
                        }}>Export Manhours Summary 
                      </button>
                      <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button btn btn-success m-2"
                        table="Small-Table"
                        filename="Project Manhours Summary"
                        sheet="tablexls"
                        buttonText={`Export Project Manhours Summary for ${
                          moment(
                            `${this.state.monthText.slice(
                              3,
                              7
                            )}-${this.state.monthText.slice(0, 2)}`
                          ).format("MMM YYYY") === "Invalid date"
                            ? ""
                            : moment(
                                `${this.state.monthText.slice(
                                  3,
                                  7
                                )}-${this.state.monthText.slice(0, 2)}`
                              ).format("MMM YYYY")
                        }`}
                      />
                      <button type="submit" className="btn btn-outline-primary"
                        onClick={e=>{
                          e.preventDefault();
                          this.TimesheetDetails()
                        }}>Export Timesheet Details 
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <div style={{ display: "none" }}>
          <table id="Small-Table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Projects</th>
                <th>
                  Normal+OT. hrs{" "}
                  {this.state.monthText.slice(0, 2) - 1 !== 0
                    ? moment(
                        `${this.state.monthText.slice(3, 7)}-${
                          this.state.monthText.slice(0, 2) - 1
                        }`
                      ).format("MMM YYYY")
                    : moment(
                        `${this.state.monthText.slice(3, 7) - 1}-12`
                      ).format("MMM YYYY")}
                </th>
                <th>
                  Normal+OT. hrs{" "}
                  {moment(
                    `${this.state.monthText.slice(
                      3,
                      7
                    )}-${this.state.monthText.slice(0, 2)}`
                  ).format("MMM YYYY")}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.smallTable.length > 0 &&
                this.state.smallTable.map((item, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.project_name}</td>
                      <td>{(+item.prevnormal + +item.prevot) / 60 || "-"}</td>
                      <td>{(+item.curnormal + +item.curot) / 60 || "-"}</td>
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2">Total:</td>
                <td>{this.state.smallTableTotal.totalPrevMonth / 60 || "-"}</td>
                <td>{this.state.smallTableTotal.totalCurMonth / 60 || "-"}</td>
              </tr>
              <tr>
                <td colSpan="2">Overall % of Ot Hours:</td>
                <td>
                  {this.state.smallTableTotal.percentOtPrevMonth
                    ? this.state.smallTableTotal.percentOtPrevMonth + "%"
                    : "-"}
                </td>
                <td>
                  {this.state.smallTableTotal.percentOtCurMonth
                    ? this.state.smallTableTotal.percentOtCurMonth + "%"
                    : "-"}
                </td>
              </tr>
            </tfoot>
          </table>
          <table id="Big-Table">
            <thead>
              <tr>
                <th rowSpan="2">Section</th>
                <th rowSpan="2">Work Station</th>
                <th colSpan={this.state.projects.length + 1}>
                  Normal Working Hours
                </th>
                <th colSpan={this.state.projects.length + 1}>OT Hours</th>
                <th rowSpan="2">Total Hours</th>
                <th rowSpan="2">%</th>
                <th rowSpan="2">Non Perform (Hrs.)</th>
              </tr>
              <tr>
                {this.state.projects.length > 0 &&
                  this.state.projects.map((item) => {
                    return <th>{item.project_name}</th>;
                  })}
                <th>total</th>
                {this.state.projects.length > 0 &&
                  this.state.projects.map((item) => {
                    return <th>{item.project_name}</th>;
                  })}
                <th>total</th>
              </tr>
            </thead>
            <tbody>
              {
              this.state.reportArray.map(o=>console.log(o))
              // this.state.reportArray &&
              //   this.state.reportArray.length > 0 &&
              //   this.state.reportArray.map(
              //     ({ department_id, workstation_id, work_minutes, ot_minutes, total_hours, percent, non_perform_minutes }, index) => {
              //       let department_name = "Grand Total";
              //       this.state.departments.filter(o=>{
              //         if (o.id == department_id) 
              //           department_name = o.name;
              //       });
              //       return (
              //         <>
              //           <tr>
              //             <td colSpan={4}>{department_name}</td>
              //             <td colSpan={this.state.projects.length * 2 + 2}></td>
              //             <td>{non_perform_minutes / 60}</td>                            
              //           </tr>
              //           { work_minutes && work_minutes.map(({ project_id, work_minutes}) => {
              //             let workstation_name = this.state.workstations.find(o => o.id == workstation_id) ?? "Subtotal";
              //             // console.log(workstation_name)
              //             // return (
              //             //   <tr>
              //             //     <td></td>
              //             //     <td>{workstation_name}</td>
              //             //     { work_minutes && work_minutes.map((e) => {
              //             //       return (<td>{e.work_minutes / 60 || "-"}</td>);
              //             //     })}
              //             //     { ot_minutes && ot_minutes.map((e) => {
              //             //         return <td>{e.ot_minutes / 60 || "-"}</td>;
              //             //     })}
              //             //     <td>{total_hours / 60}</td>
              //             //     <td>{workstation_id === workstation_name ? percent: ""}</td>
              //             //   </tr>
              //             //   );
              //             }
              //           )}
              //         </>
              //       );
              //     }
              //   )
              }
              <tr>
                {/* <td></td>
                <td>Every Dept / Project</td>
                {this.state.total.totalArray.length > 0 &&
                  this.state.total.totalArray.map((e) => {
                    return <td>{e.work_minutes / 60 || "-"}</td>;
                  })}
                {this.state.total.totalArray.length > 0 &&
                  this.state.total.totalArray.map((e) => {
                    return <td>{e.ot_minutes / 60 || "-"}</td>;
                  })}
                <td>{this.state.total.totalHours / 60}</td>
                <td>{this.state.total.percentOt + "%"}</td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
